import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateViewZonePlaylistDocument } from './create.generated';

export const useCreateViewZonePlaylist = (
  options: ApiOptions<typeof CreateViewZonePlaylistDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(CreateViewZonePlaylistDocument, {
    ...useNotifications(CreateViewZonePlaylistDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.view_zone_playlists.add_success'),
    }),

    ...options,
  });
};
